import React, { useEffect, useRef, useState } from 'react';
import './registry.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import * as ReactDOM from 'react-dom';
import { isMobile } from 'react-device-detect';
import {
  getJsonFromStorage,
  getPaginationOpts,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { loadRegistryHistoryList } from '../actions';
import { getSystemData } from '../../System/reducer';
import { getRegisterData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import {
  dateTimeFormatter, subjectFormatter, userPositionFormatter,
} from '../../../utils/formatters';
import RegistryHistoryDialog from './RegistryHistoryDialog';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { loadUserActionById } from '../../ReferenceInformation/actions';
import { getReferenceInformationData } from '../../ReferenceInformation/reducer';
import { REGION_REGISTRY_MODULE } from '../../../configs/moduleNames';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import getDefaultSort from '../../../utils/getDefaultSort';
import RowFilterForm from '../../FilterTemplate/components/RowFilterForm';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import MobileApplicationHistoryFooter from '../../Application/components/MobileApplicationHistoryFooter';
import PropertyGrid from '../../../components/base/Grid/PropertyGrid';

export default function RegistryHistoryPage() {
  const blockRef = useRef(null);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const subject_id = searchParams.get('subject_id');
  const subject_type = searchParams.get('subject_type');

  const { updatePeriod } = useSelector(getSystemData);
  const {
    loadingRegistryHistoryList,
    registryHistoryList = [],
    registryHistoryListMeta = {},
    loadingRegistryHistory,
  } = useSelector(getRegisterData);

  const {
    currentUserActivity,
  } = useSelector(getReferenceInformationData);
  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    search: '', registry: '', created_at: '',
  };
  const {
    reset, getValues, control, setValue, watch,
  } = useForm({ defaultValues: getJsonFromStorage('registry-history-filter', defaultFilterValues) });

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].registryHistoryListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
      sort,
    };
    const p1 = dispatch(loadRegistryHistoryList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => loadData({ page: 1 }));
    return () => subscription.unsubscribe();
  }, [watch]);
  useEffect(() => setValue('subject_id', subject_id), [subject_id]);
  useEffect(() => setValue('subject_type', subject_type), [subject_type]);

  const handleSelectItem = i => {
    const p1 = dispatch(loadUserActionById(i.id)).then(data => {
      setSelectedItem(i);
    }).catch(responseLogWithNotification);
  };

  const columns = [
    {
      dataField: 'causer',
      text: 'Пользователь',
      headerClassName: 'user-column',
      formatter: userPositionFormatter,
    },
    {
      dataField: 'created_at',
      text: 'Дата и время',
      headerClassName: 'date-time-column',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'context',
      text: 'Субъект',
      headerClassName: 'module-column',
      formatter: (_, item) => subjectFormatter(item),
    },
    {
      dataField: 'description',
      text: 'Изменения в объекте',
      headerClassName: 'changes-to-object-column',
    },
  ];

  const [sort, setSort] = useState(getDefaultSort(columns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const renderFooter = () => {
    const element = document.getElementById('app-content-footer');
    if (!element) {
      return null;
    }
    return ReactDOM.createPortal(<MobileApplicationHistoryFooter
      control={control}
      defaultFilterValues={defaultFilterValues}
      getValues={getValues}
      reset={reset}
      page={PAGE_TYPE.REGION_REGISTRY_HISTORY}
    />, element);
  };

  return (
    <div className="page application-page">
      <TimerLoader global loading={loadingRegistryHistoryList || loadingRegistryHistory} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.region.registry.history' })}</div>
        {!isMobile ? (
          <FilterRow>
            <RowFilterForm
              control={control}
              getValues={getValues}
              defaultValues={{}}
              page={PAGE_TYPE.REGION_REGISTRY_HISTORY}
            />
          </FilterRow>
        ) : null}
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          {!isMobile ? (
            <div className="grid-wrapper frame">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <CustomizedGrid
                  data={registryHistoryList}
                  columns={columns}
                  changeSort={changeSort}
                  sort={sort}
                  name="registry-history-list"
                  onDoubleClickByRow={handleSelectItem}
                  rowClassFormatter={item => (selectedItem && item.id === selectedItem.id ? 'clickable-table-row selected' : 'clickable-table-row')}
                />
              </div>
            </div>
          ) : (
            <PropertyGrid
              data={registryHistoryList}
              columns={columns}
              changeSort={changeSort}
              sort={sort}
              name="registry-history-list"
              onDoubleClickByRow={handleSelectItem}
              rowClassFormatter={item => (selectedItem && item.id === selectedItem.id ? 'clickable-table-row selected' : 'clickable-table-row')}
            />
          )}
          <Pagination meta={registryHistoryListMeta} list={registryHistoryList} handleChangeMeta={loadData} />
        </div>
      </div>
      {selectedItem && currentUserActivity ? <RegistryHistoryDialog close={() => setSelectedItem(null)} /> : null}
      {isMobile ? renderFooter() : null}
    </div>
  );
}
